import { c as createFocusTrap } from './focus-trap.esm-CwGG3vRJ.js';
import { removeHashFromUrl } from './utils-remove-hash-from-url.js';

/**
 * Toggle the dialog.
 * @param {HTMLElement} dialog - The dialog to toggle.
 */
function toggleDialog(dialog) {
  // If the dialog is already open, close it
  if (dialog.open) {
    // Deactivate the focus trap if it exists
    if (dialog.trap) {
      dialog.trap.deactivate();
    }

    // Close the dialog after the focus trap is deactivated
    setTimeout(() => {
      dialog.close();
    }, 100);
  } else {
    // If the dialog is not open, open it
    dialog.showModal();

    // Create the focus trap if it doesn't exist
    if (!dialog.trap) {
      dialog.trap = createFocusTrap(dialog, {
        // Allow clicks outside the dialog to close the dialog
        allowOutsideClick: true,
      });
    }
    // Activate the focus trap
    dialog.trap.activate();
  }
}

/**
 * Listen for dialog:close events
 */
subscribe('dialog:close', ({ dialogId }) => {
  const element = document.getElementById(dialogId);

  if (element instanceof HTMLDialogElement) {
    toggleDialog(element);
  }

  removeHashFromUrl();
});

/**
 * Listen for key:escape events
 */
subscribe('key:escape', () => {
  const dialog = document.querySelector('dialog[open]');
  if (dialog) toggleDialog(dialog);

  removeHashFromUrl();
});

/**
 * Listen for clicks on data-dialog-controller
 */
document.addEventListener('click', (event) => {
  const target = event.target;

  // Handle dialog controllers
  if (target.closest('[data-dialog-controller]')) {
    const dialogId = target.closest('[data-dialog-controller]').getAttribute('aria-controls');
    const dialog = document.getElementById(dialogId);
    if (!dialog) {
      console.error(`Dialog with id '${dialogId}' not found`);
      return;
    }

    toggleDialog(dialog);
  }

  // Handle click on dialog background to close
  if (target.nodeName === 'DIALOG') {
    target.close();

    removeHashFromUrl();
  }
});
